/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

 $(document).ready(function() {
   $('.custom-instafeed-play__button').click(function() {
      // Add the "is-open" class to the modal
      $('.micromodal-slide').addClass('video-run');
      // $('#popup-video').addClass('video-run');
      // $('#popup-video').addClass('is-open');
    });
   $('.popup-video-close').click(function() {
      const data_id = $(this).attr('data-id');
      $('#'+data_id).removeClass('video-run');
      $('#'+data_id).removeClass('is-open');
   });
   $('.custom-instafeed-popup-play__button').click(function() {
        const data_id = $(this).attr('data-id');
       $('#'+data_id).addClass('video-run');
      $('#'+data_id).addClass('is-open');
   });
 });

document.addEventListener("DOMContentLoaded", (event) => {
  const reload = document.querySelector(".btn--add-to-cart-pdp");
  reload.addEventListener('click', (e) => {
    console.log("test");
    const ele = document.getElementsByClassName('product-add-popdown');
    ele[0].style.display = 'none';
  const listener = (e) => {
      document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: false,
      })
    );
    document.removeEventListener('theme:cart:change', listener);
  };
  document.addEventListener('theme:cart:change', listener);
});
});


function yotpoSelectedSellingPlanChanged(selectedSellingPlanGroup, selectedSellingPlan, isBuyOnce, selectedProductPrice) {
 const price = (selectedProductPrice / 100).toFixed(2);
 const addToCartButtonPriceElement = document.querySelector('.custom-data-button-price-get');
 addToCartButtonPriceElement.textContent = '$' + price;
}


// Klaviyo popup open 
document.getElementById('annoucement_popup').addEventListener('click', function() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'VFfiaB']);
});

// document.addEventListener('DOMContentLoaded', function() {
//   const target = document.querySelector('giftnote-button');
  
//   if (target) {
//     const observer = new MutationObserver(function(mutationsList, observer) {
//       for (const mutation of mutationsList) {
//         if (mutation.type === 'childList' && target.shadowRoot) {
//           const root = target.shadowRoot;
//           const giftButton = root.querySelector('#button[data-vendor="Willow By The Sea"]');
          
//           if (giftButton) {
//             // Apply the desired styles to the button element
//             giftButton.style.fontFamily = 'var(--TYPE-STACK-BUTTON)';
//             giftButton.style.textTransform = 'uppercase';
//             giftButton.style.letterSpacing = '-0.108375px';
//             giftButton.style.marginBottom = '10px';
//             giftButton.style.transition = 'background-color .5s cubic-bezier(.215,.61,.355,1)';
//             giftButton.style.borderRadius = '0';
//             giftButton.style.fontSize = '14px';
//             giftButton.style.fontWeight = '800';
//             giftButton.style.height = '44.84px';
//             giftButton.style.borderColor = '#98bbd0';
//             giftButton.style.color = '#98bbd0';
            
//             // Stop observing after the button is found and styled
//             observer.disconnect();
//           }
//         }
//       }
//     });

//     observer.observe(target, { childList: true, subtree: true });
//   }
// });



//Mobile menu
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sliderow').forEach(button => {
    button.addEventListener('click', function() {
      // Toggle active class on the button itself
      this.classList.toggle('active');

      // Find the corresponding mobile__menu__dropdown element
      let nextSibling = this.nextElementSibling;
      while (nextSibling && !nextSibling.classList.contains('mobile__menu__dropdown')) {
        nextSibling = nextSibling.nextElementSibling;
      }

      // If found, toggle the active class on it
      if (nextSibling && nextSibling.classList.contains('mobile__menu__dropdown')) {
        nextSibling.classList.toggle('active');
      }
    });
  });
});